import React from 'react';
import classNames from 'classnames';

class TextareaInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = { active: false };
  }

  makeActive() {
    if (this.state.active === false) {
      this.setState({
        active: true,
      });
    }
  }

  render() {
    const { className } = this.props;
    const error = this.props.meta.touched && this.props.meta.error ? 'error' : '';
    const disabled = this.props.disabled ? 'disabled' : '';
    const active = this.state.active ? 'active' : '';
    const errorClass = this.props.className + 'small error';

    return (
      <div className="form-field">
        <label htmlFor={this.props.id}>{this.props.label}</label>
        <textarea
          {...this.props.input}
          id={this.props.id}
          name={this.props.name}
          className={classNames(error, active, disabled, ` ${this.props.className} `)}
          disabled={this.props.disabled ? true : false}
          placeholder={this.props.placeholder}
          onClick={this.makeActive.bind(this)}
          onFocus={this.props.input.onFocus}
          onBlur={this.props.input.onBlur}
          onKeyPress={this.props.onKeyPress}
        />
        { this.props.meta.touched && this.props.meta.error && <p className={errorClass}>{this.props.meta.error}</p> }
      </div>
    );
  }
}

TextareaInput.propTypes = {
  onFocus: React.PropTypes.func,
  onBlur: React.PropTypes.func,
  onClick: React.PropTypes.func,
  onKeyPress: React.PropTypes.func,
};

export default TextareaInput;



/** WEBPACK FOOTER **
 ** ./src/components/form-input-textarea/index.js
 **/